<template>
  <div id="code-search">
    <v-app>
      <v-container>
     <v-layout row justify-center>
    <v-dialog v-model="fileInput" persistent max-width="400">
      <v-card>
         <!-- <form novalidate class="md-layout" @submit.prevent="uploadFile"> -->
        <v-card-title class="headline">Télécharger la photo</v-card-title>
        <v-card-media
          v-if="imageData.length > 0"
          :src="imageData"
          height="300px"
        ></v-card-media>
        <v-card-text>
           <input
            type="file"
            @change="previewImage"
            accept="image/*"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="fileInput=false">Terminer</v-btn>
          <v-btn color="green darken-1" @click="previewFile" flat>Télecharger</v-btn>
        </v-card-actions>
        <!-- </form> -->
      </v-card>
    </v-dialog>

    <!-- Main Vue -->
    <v-flex xs12 sm6>
      <v-toolbar color="indigo" dark>
        <v-toolbar-side-icon></v-toolbar-side-icon>
        <v-toolbar-title>Modification de photo</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn icon>
          <v-icon @click="mainView = true">search</v-icon>
        </v-btn> -->
      </v-toolbar>

      <v-card>
        <v-container
          fluid
          grid-list-md
        >
          <v-layout row wrap>
            <v-flex
             xs12
            >
              <v-card>
                <video ref="video" class="camera-stream"/>
                <v-card-actions>
                  <span><h3>Ajouter ou Modifier:</h3></span>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                  <v-btn slot="activator" @click="capture" icon>
                    <v-icon>camera</v-icon>
                  </v-btn>
                   <span>Appuyez pour prendre la photo</span>
                  </v-tooltip>
                   <v-tooltip bottom>
                  <v-btn icon slot="activator" @click="fileInput = true">
                    <v-icon>attach_file</v-icon>
                  </v-btn>
                  <span>Appuyez pour changer la photo</span>
                   </v-tooltip>
                    <v-tooltip bottom>
                  <v-btn icon @click="deleteMember" slot="activator">
                    <v-icon>delete</v-icon>
                  </v-btn>
                   <span>Appuyez pour supprimer ce membre</span>
                    </v-tooltip>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
  <v-btn @click="goBack" color="primary">Retour</v-btn>
      </v-container> 
    </v-app>   
  </div>
</template>
     
<script>
/* eslint-disable */
import { db } from '@/api/firebaseInit';
import firebase from 'firebase';
import { storage } from '@/api/firebaseInit';

const {
  getStats,
  getUserMedia,
  MediaStream,
  MediaStreamTrack,
  RTCIceCandidate,
  RTCPeerConnection,
  RTCSessionDescription 
} = require('@twilio/webrtc');

export default {
  name: 'code-search',
  data() {
    return {
      mainView: true,
      members: [],
      cards: [
        // { firstName: 'Membre', imageUrl: './src/assets/avatar.png', flex: 12 }
      ],
      file: null,
      mediaStream: null,
      imageData: '',
      memberFound: false,
      loading: true,
      fileInput: false,
      newAccessCode: '',
      rules: {
        required: value => !!value || 'Le Code d\'accès est obligatoire.',
        counter: value => value.length <= 5 || '5 charactéres maximum'
      },
      accessCode: '',
      accessLevel: '',
      imageUrl: './src/assets/avatar.png',
      currentUser: null,
      createdBy: firebase.auth().currentUser.displayName
    };
  },
  // created () {
  //   const videoConstraints = {};
  //       videoConstraints.facingMode = 'environment';
  //           navigator.mediaDevices.getUserMedia({videoConstraints})
  //       .then(mediaStream => {
  //           this.mediaStream = mediaStream
  //         this.$refs.video.srcObject = mediaStream
  //         this.$refs.video.play()
  //       //   navigator.mediaDevices.enumerateDevices().then(gotDevices);
  //       })
  //       .catch(error => console.error('getUserMedia() error:', error))
  //   },
  computed: {
    member_id () {
      return this.$store.getters.getCurrentMemberId;
    }
  },
    created () {
      
         const videoConstraints = {};
    videoConstraints.facingMode = 'environment';
  
  const constraints = {
    video: videoConstraints,
    audio: false
  };
      getUserMedia(constraints)
        .then(mediaStream => {
            this.mediaStream = mediaStream
          this.$refs.video.srcObject = mediaStream
          this.$refs.video.play()
        })
        .catch(error => console.error('getUserMedia() error:', error))
    },
    destroyed () {
    const tracks = this.mediaStream.getTracks()
    tracks.map(track => track.stop())
  },
  methods: {
     capture () {
       const that = this
    const mediaStreamTrack = this.mediaStream.getVideoTracks()[0]
  const imageCapture = new window.ImageCapture(mediaStreamTrack)
  return imageCapture.takePhoto().then(blob => {
  
    const pictRef = storage.ref().child(`images/picture-${new Date().getTime()}`)
    pictRef.put(blob)
    .then(function(snapshot) {
    pictRef.getDownloadURL().then((url) => {
        that.saveImageUrl(url)
    }).catch(function(error) {
      alert(`${error}`)
      })
         })
        })
     },
       saveImageUrl (imageUrl) {
          var that = this
            db.collection('Census').doc(this.member_id)
            .update({
                imageUrl: imageUrl
            })
            .then(function(docRef){
              that.$store.commit('memberPhoto', imageUrl)
                alert(`La photo a été enregistée`);
                that.goBack()
            })
            .catch(function(error) {
                console.error("Error adding document: ", error);
            })
        },
    uploadFile() {
      this.previewImage();
    },
    previewImage: function(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = e => {
          // Note: arrow function used here, so that 'this.imageData' refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
          this.file = input.files[0];
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewFile () {
      const tracks = this.mediaStream.getTracks()
      tracks.map(track => track.stop())
      var storageRef = storage.ref();

      // dynamically set reference to the file name
      var thisRef = storageRef.child(`images/picture-${new Date().getTime()}`);

      // put request upload file to firebase storage
      thisRef.put(this.file)
      .then((snapshot) => {
    thisRef.getDownloadURL().then((url) => {
      this.imageUrl = url
        db.collection('Census')
          .doc(this.member_id)
          .update({
            imageUrl: this.imageUrl
          })
          .then(() => {
            this.$store.commit('memberPhoto', this.imageUrl)
                alert(`L'image a été enregistée`);
                this.goBack()
          })
      });
      })
    },
    goBack () {
      this.$router.go(-1);
    },
    deleteMember () {
      const that = this;
      if (confirm('Etes-vous sûre de vouloir supprimer ce membre?')) {
        db.collection('Census')
          .doc(that.member_id)
          .delete()
          .then(function () {
            alert(`Ce membre a été suprimé`);
            that.cards = [];
            that.goBack()
          });
      }
    }
  }
};
</script>
<style scoped>
.camera-modal {
        width: 50%;
        height: 50%;
        top: 0;
        left: 0;
        /* position: absolute; */
        background-color: white;
        z-index: 10;
    }
    .camera-stream {
        width: 100%;
        max-height: 100%;
    }

    .camera-modal-container {
        position: absolute;
        bottom: 0;
        width: 50%;
        align-items: center;
        margin-bottom: 24px;
    }
    .take-picture-button {
        display: flex;
    }
</style>




// WEBPACK FOOTER //
// src/pages/AppPhoto.vue